import React from 'react';
import { Flex, Box } from '@components/layout/Grid';
import styled from 'styled-components';
import SvgCheckmark from '@assets/Checkmark';
import {
  ProgramCategory,
  ProgramSurveyElementFieldsFragment,
} from '@gql/generated';
import { Trans } from '@lingui/react';
import Button from '@components/buttons';

const Icon = styled.span`
  display: flex;
  align-items: center;
  border: 3px solid #32847e;
  border-radius: 50%;
  padding: 20px;

  svg {
    height: 24px;
    margin-bottom: -6px;

    path {
      fill: #32847e;
    }
  }
`;

const Title = styled.p`
  color: #242424;
  font-size: 18px;
  font-weight: 500;
  line-height: 17px;
  text-align: center;
  margin: 24px auto 15px;
`;

const Desc = styled.p`
  color: #242424;
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  margin: 0;
`;

const Close = styled.button<{ programCategory: ProgramCategory }>`
  color: ${({ theme, programCategory }) =>
    programCategory === ProgramCategory['Challenges']
      ? theme.colors.primary.green
      : theme.colors.primary.stone};
  font-size: 13px;
  font-weight: 600;
  border: 2px solid currentColor;
  border-radius: 3px;
  padding: 12px 25px;
  background: none;
  cursor: pointer;
`;

type Props = {
  survey: ProgramSurveyElementFieldsFragment['survey'];
  programCategory: ProgramCategory;
  closeModal(): void;
};

const ProgramSurveyThankyou = (props: Props) => {
  const { survey, programCategory, closeModal } = props;

  return (
    <Flex flexDirection="column" alignItems="center" mx={[10, 20, 40]}>
      <Icon>
        <SvgCheckmark />
      </Icon>
      <Title>
        {survey.content.page3Title || (
          <Trans id="programs_2022.survey.thank_you_title" />
        )}
      </Title>
      <Desc>
        {survey.content.page3Description || (
          <Trans id="programs_2022.survey.thank_you_desc" />
        )}
      </Desc>
      <Box mt={40}>
        <Close programCategory={programCategory} onClick={() => closeModal()}>
          <Trans id="programs_2022.survey.close_modal_button" />
        </Close>
        {survey.content.page3ButtonUrl && survey.content.page3ButtonText ? (
          <Button
            href={survey.content.page3ButtonUrl}
            appearance={
              programCategory === ProgramCategory['Challenges']
                ? 'green'
                : 'stone'
            }
          >
            {survey.content.page3ButtonText}
          </Button>
        ) : null}
      </Box>
    </Flex>
  );
};

export default ProgramSurveyThankyou;
